import { login, ssologion, getInfo, getssoUrl, getChannelSiteInfo ,getuserinfo} from '@/api/user'
import { getPhone } from '@/api/version'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  infonum: 0,
  ssourl: localStorage.getItem('SSOURL') || '',
  loginPhone: localStorage.getItem('LOGINPHONE') || '',
  channel_info: JSON.parse(localStorage.getItem('CHANNEL_INFO')) || null
}

const mutations = {
  SET_LOGINPHONE: (state, loginPhone) => {
    state.loginPhone = loginPhone
  },
  SET_SSOURL:(state,ssourl)=>{
    state.ssourl = ssourl
  },
  SET_INFONUM: (state, infonum) => {
    state.infonum = infonum
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_CHANNEL_INFO: (state, channel_info) => {
    state.channel_info = channel_info
  }
}

const actions = {
  getloginPhone({ commit }, loginPhone) {
    return new Promise(async (resolve, reject) => {
      let result = await getPhone()
      if (result.code == 1) {
        let data = result.data.phone
        commit('SET_LOGINPHONE', data)
        localStorage.setItem('LOGINPHONE', data)
      }
          // let params = {
          //   type: 2,
          //   site_type: 8
          // }
          // await getChannelSiteInfo(params).then(res => {
          //   if (res.code == 1) {
          //     // 原来的，不动，简单做了一个拆分
          //     if (res.data.channel_site) {
          //       commit('SET_CHANNEL_INFO', res.data.channel_site[0])
          //       localStorage.setItem('CHANNEL_INFO', JSON.stringify(res.data.channel_site[0]))
          //       let channel_id=res.data.channel_site[0].channel_id
          //       if (channel_id == 0) {
          //         var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          //         link.type = 'image/x-inon';
          //         link.rel = 'icon';
          //         link.href = '/icon.ico'
          //         document.getElementsByTagName('head')[0].appendChild(link);
          //       } else {
          //         var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          //         link.type = 'image/x-inon';
          //         link.rel = 'icon';
          //         link.href = '/favicon.ico'
          //       }
          //     }
          //     resolve()
          //   } // if end
          // })
      //   }
      // }).catch(error => {
      //   reject()
      // })
    })
  },
  // user login
  login({ commit }, userInfo) {
    // //debugger
    const { phone, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ phone: phone.trim(), password: password }).then(response => {
        const data = response.data
        commit('SET_TOKEN', data.access_token)
        setToken(data.access_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getssourl({commit},data){
    return new Promise((resolve, reject) => {
      getssoUrl(data).then(response => {
      
        if (response.code == 1) {
        
          commit('SET_SSOURL', response.data.channel_agreement?response.data.channel_agreement.sso_url:'sso.jxhh.com')
          localStorage.setItem('SSOURL',response.data.channel_agreement?response.data.channel_agreement.sso_url:'sso.jxhh.com')
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ssoLogion({ commit, dispatch }, data) {
   debugger
    return new Promise((resolve, reject) => {
      ssologion(data).then(response => {
        const date = response.data
        if (response.code == 1) {
          debugger
          commit('SET_TOKEN', date.access_token)
          setToken(date.access_token)

          dispatch('getloginPhone')
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getuserinfo().then(response => {
        if(response.code==0){
          let ssourl = localStorage.getItem('SSOURL')
          var ssa = window.location.host
          var ht = document.location.protocol
            setTimeout(function() {
              if (ssa == 'localhost:9527') {
               	 window.location.href = ht+'//'+ssourl+'/api/v2/logout?redirect='+ht+'//'  + ssa + '/login'
              } else {
               	window.location.href = ht+'//'+ssourl+'/api/v2/logout?redirect='+ht+'//'  + ssa + '/login'
              }
            }, 1000)
        }
        // let data  = response.data
        if(response.data.is_area_agent==1){
          localStorage.setItem('a',1)
        }else{
          localStorage.setItem('a',0)
        }
        if(response.data.is_retail_agent==1){//分销
          localStorage.setItem('b',1)
        }else{
          localStorage.setItem('b',0)
        }
        if(response.data.is_invite_agent==1){//invite 招商
          localStorage.setItem('c',1)
        }else{
          localStorage.setItem('c',0)
        }
        const data = {
          // name: response.data.name,
          name:"scm",
          roles: ['admin','regionalpolicy'],
          avatar: 'https://img2.jxhh.com/appicon/b4d119d7bb8b58a46ff292dd75d49d59.png',
          introduction: 'qq'
        }

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        debugger
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()

      localStorage.removeItem('SSOURL')
      localStorage.removeItem('LOGINPHONE')
      localStorage.removeItem('CHANNEL_INFO')

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
